import progression from '../../../data/class-progression.json';

export type AdvancedClassId='sword-soldier'|'spear-soldier'|'forest-hunter'|'shaman';
export type ClassId='villager'|AdvancedClassId;
export type ClassSkill={
  id:string;
  classId:AdvancedClassId;
  name:string;
  level:number;
  power:number;
  range:number;
  cooldown:number;
  effect:string;
  icon:string;
  tag:string;
  cost:number;
  radius:number;
  duration:number;
};
export type Shortcut={kind:'skill'|'item';id:string}|null;

export const PROFESSIONS=progression.classes as {id:ClassId;name:string;description:string}[];
export const CLASS_SKILLS=progression.skills as ClassSkill[];
export const CLASS_UNLOCK_LEVELS=[10,15,20,25,30] as const;
export const MAX_CLASS_LEVEL=progression.maxLevel;

export const skillById=(id:string):ClassSkill|undefined=>CLASS_SKILLS.find(s=>s.id===id);
export const skillsForClass=(id:ClassId):ClassSkill[]=>id==='villager'?[]:CLASS_SKILLS.filter(s=>s.classId===id);
export const unlockedSkillsFor=(id:ClassId,level:number):ClassSkill[]=>skillsForClass(id).filter(s=>level>=s.level);
export const defaultShortcuts=(id:ClassId,level=1):Shortcut[]=>{
  const slots:Shortcut[]=unlockedSkillsFor(id,level).slice(0,4).map(s=>({kind:'skill',id:s.id}));
  while(slots.length<4)slots.push(null);
  return slots;
};
export function isClassId(value:unknown):value is ClassId {
  return typeof value==='string'&&PROFESSIONS.some(c=>c.id===value);
}
export function isAdvancedClass(value:unknown):value is AdvancedClassId {
  return isClassId(value)&&value!=='villager';
}
export function canAssign(binding:Shortcut,classId:ClassId,level:number,owned:string[]):boolean {
  if(!binding)return true;
  if(binding.kind==='item')return binding.id==='potion'||owned.includes(binding.id);
  if(binding.kind!=='skill')return false;
  const s=skillById(binding.id);
  return !!s&&s.classId===classId&&level>=s.level;
}
export const DEFAULT_SHORTCUT_KEYS=['q','e','r','f'];
export function validShortcutKeys(keys:string[]):boolean {
  return keys.length===4&&new Set(keys).size===4&&keys.every(k=>/^[a-z0-9]$/.test(k)&&!['a','d','s','w','j','z','c','v','p','i','k','u'].includes(k));
}
